<template>
  <v-container fluid fill-height class="login-container">
    <img class="login-bg" src="@/assets/slice2.png" alt />
    <v-layout align-center justify-center>
      <v-flex xs12 sm8 md4>
        <v-card class="login-form">
          <div class="login-logo">
            <img src="@/assets/logo.png" alt="logo" class="center-block" />
          </div>
          <v-card-text>
            <v-form v-model="valid">
              <v-alert :value="error" color="error" icon="mdi-warning" outlined>{{msj}}</v-alert>
              <v-text-field
                required
                :rules="required"
                class="user-prefix"
                v-model="text1"
                label
                type="number"
                solo
              ></v-text-field>

              <v-text-field
                :rules="required"
                required
                id="password"
                solo
                v-model="text2"
                label="CONTRASEÑA"
                type="password"
              ></v-text-field>
            </v-form>
            <v-btn
              :disabled="!valid"
              block
              color="primary"
              @click="validateLogin"
              rounded
              class="login-separador-btn"
            >Iniciar sesión</v-btn>
            <v-btn block color="secondary" to="/signup" rounded>Regístrate</v-btn>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
    <v-snackbar :timeout="2000" v-model="snackbarLogin">
      {{ snackbarLoginText }}
      <v-btn text @click.native="snackbarLogin = false">Close</v-btn>
    </v-snackbar>
  </v-container>
</template>

<script>
// import Helpers from "../utils/helpers";
import Server from "../utils/server";
export default {
  mounted() {
    if (this.login === true) {
      this.$router.push("home");
    }
  },
  data: function () {
    return {
      valid: false,
      text1: "",
      text2: "",
      error: false,
      msj: "",
      required: [(v) => !!v || "El campo es obligatorio"],
      emailRules: [
        (v) => !!v || "El campo es obligatorio",
        (v) =>
          /^[_a-z0-9-]+(\.[_a-z0-9-]+)*@[a-z0-9-]+(\.[a-z0-9-]+)*(\.[a-z]{2,4})$/.test(
            v
          ) || "El email debe ser valido",
      ],
      snackbarLogin: false,
      snackbarLoginText: "Usuario o Clave invalidos",
    };
  },
  computed: {
    login: function () {
      return this.$store.getters.login;
    },
  },
  methods: {
    validateLogin: function () {
      // const _this = this;

      // this.$store.dispatch('login', true)
      // this.$router.push('packages')

      var formData = new FormData();
      formData.append("text1", this.text1);
      formData.append("text2", this.text2);
      formData.append("device", window.MobileApi.device);

      this.$http.post(Server.login, formData).then(
        (response) => {
          console.log(response.body.resultado);
          if (response.body.resultado != 0) {
            this.$store.dispatch("login", true);
            this.$router.push("home");
            window.MobileApi.setSessionId(response.body.resultado);
          } else {
            this.snackbarLogin = true;
          }
        },
        () => {
          this.error = true;
          this.msj = "An error has occurred try again later";
        }
      );

      // Helpers.getJson(Server.login, 'POST', formData, function (json) {
      //   console.log(json.resultado)
      //   if (json.resultado > 0) {
      //     _this.$store.dispatch('login', true)
      //     _this.$router.push('packages')
      //   } else {
      //     _this.snackbarLogin = true
      //   }
      // })
    },
  },
};
</script>

<style lang="sass" scoped>
@import "../assets/css/login.scss"
</style>